import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { find, store } from "../../services/service";
import {
  ATTRIBUTION_RDV_EQUIPE,
  EDIT_INTENTION_PBO,
  EQUIPE_COORDO,
  LISTE_BRIN_DISPO,
  LISTE_PBO_DISPO,
} from "../../Utils/constant";

const PrestataireAttributionCoordo = () => {
  const [msg, setMsg] = useState("");
  const [assignModalItem, setAssignModalItem] = useState(null);
  const [selectedPrestataire, setSelectedPrestataire] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [attributions, setAttributions] = useState([]);
  const [equipes, setEquipe] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [listePbo, setListePbo] = useState([]);
  const [listeBrin, setListeBrin] = useState([]);
  const [submited, setSubmited] = useState(false);
  const [selectedBrin, setSelectedBrin] = useState(null);
  const [selectedPbo, setSelectedPbo] = useState(null);
  const [loader, setLoader] = useState(true);
  // États de chargement pour PBO et Brin
  const [loadingPbo, setLoadingPbo] = useState(false);
  const [loadingBrin, setLoadingBrin] = useState(false);

  const getEquipeListe = async (prestataire) => {
    setLoader(true);
    await find(`${EQUIPE_COORDO}?prestataireId=${prestataire}`).then((res) => {
      setLoader(false);
      setEquipe(res?.data?.donnee);
    });
  };

  const getListePbo = async (latitude, longitude) => {
    setLoadingPbo(true);
    setListePbo([]);
    setListeBrin([]);
    setSelectedPbo("");
    setSelectedBrin("");

    try {
      const res = await find(
        LISTE_PBO_DISPO + `?latitude=${latitude}&longitude=${longitude}`,
      );
      setListePbo(res?.data?.donnee || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des PBO");
      setListePbo([]);
    } finally {
      setLoadingPbo(false);
    }
  };

  const getListBrin = async (pbo) => {
    setLoadingBrin(true);
    setListeBrin([]);
    setSelectedBrin("");

    try {
      const res = await find(`${LISTE_BRIN_DISPO}/${pbo}`);
      setListeBrin(res?.data?.donnee || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des brins");
      setListeBrin([]);
    } finally {
      setLoadingBrin(false);
    }
  };

  const getDataListe = async (param, page) => {
    setLoading(true);
    await find(
      `${ATTRIBUTION_RDV_EQUIPE}?page=${page ?? 0}&param=${param}&size=8`,
    ).then((res) => {
      setLoading(false);
      setAttributions(res?.data);
    });
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setIsSearching(true);
    getDataListe(value, 0).finally(() => setIsSearching(false));
  };

  const moreEnAttente = (page) => {
    getDataListe(searchTerm, page - 1);
  };

  const Submit = async (e) => {
    e.preventDefault();

    if (!selectedPbo || !selectedBrin) {
      toast.error("Veuillez sélectionner un PBO et un Brin");
      return;
    }

    setSubmited(true);
    setMessage("");

    try {
      await store(
        EDIT_INTENTION_PBO +
          `/${assignModalItem?.abonnement?.id}/${selectedPbo}/${selectedBrin}`,
        "application/json",
        {},
      );

      getDataListe("", 0);
      setSelectedBrin("");
      setSelectedPbo("");
      setListePbo([]);
      setListeBrin([]);
      setMessage("");
      document.getElementById("edit").close();
      toast.success("Modification effectuée avec succès");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.donnee || "Erreur lors de la modification";
      setMessage(errorMsg);
      toast.error(errorMsg);
    } finally {
      setSubmited(false);
    }
  };

  const handleAssignEquipe = async () => {
    if (!assignModalItem || !selectedPrestataire) return;

    setIsAssigning(true);
    setMsg("");
    try {
      const res = await store(
        `/commerciale/rdv-corbeille/v3/${assignModalItem.abonnement?.id}/attribuer-equipe/${selectedPrestataire}`,
        "application/json",
        {},
      );
      if (res.status === 200) {
        getDataListe(searchTerm, 0);
        document.getElementById("reattribution").close();
        setAssignModalItem(null);
        setSelectedPrestataire("");
        toast.success("Prestataire affecté avec succès");
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.donnee || "Erreur lors de l'attribution";
      setMsg(errorMsg);
      toast.error(errorMsg);
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    getDataListe("", 0);
  }, []);

  return (
    <div className="">
      {/* Modal Affecter Prestataire */}
      <dialog id="reattribution" className="modal">
        <div className="modal-box w-96">
          <h3 className="font-bold text-lg">Affecter une equipe</h3>
          <p className="text-sm text-gray-500 mb-3">
            Sélectionnez l'equipe à affecter pour ce rendez-vous.
          </p>
          {msg && <p className="text-red-500 text-sm mb-2">{msg}</p>}
          {equipes?.length === 0 && !loader ? (
            <p className="text-xs text-red-500">
              Aucune equipe disponible pour ce prestataire.
            </p>
          ) : (
            <div className=" mb-3">
              <select
                value={selectedPrestataire}
                onChange={(e) => setSelectedPrestataire(e.target.value)}
                className=" select select-bordered w-full"
                disabled={isAssigning || loader}
              >
                <option value="">
                  {loader
                    ? "Chargement des equipes..."
                    : "-- Choisir une equipe --"}
                </option>
                {equipes?.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.designation}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="modal-action">
            <button
              onClick={handleAssignEquipe}
              disabled={isAssigning || !selectedPrestataire}
              className={`btn btn-sm ${
                isAssigning || !selectedPrestataire
                  ? "btn-disabled opacity-50"
                  : "bg-main text-black border-main"
              }`}
            >
              {isAssigning ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Affectation...
                </>
              ) : (
                "Affecter"
              )}
            </button>
            <button
              onClick={() => {
                document.getElementById("reattribution").close();
                setAssignModalItem(null);
                setMsg("");
              }}
              disabled={isAssigning}
              className="btn btn-sm"
            >
              Annuler
            </button>
          </div>
        </div>
      </dialog>

      {/* Modal Modifier PBO/Brin */}
      <dialog id="edit" className="modal">
        <div className="modal-box max-w-xl">
          <div className="modal-action">
            <h1 className="mr-auto text-2xl font-bold font-mtn">
              Modification de l'abonnement
            </h1>
            <form method="dialog">
              <button
                id="fermer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                onClick={() => {
                  setListePbo([]);
                  setListeBrin([]);
                  setSelectedPbo("");
                  setSelectedBrin("");
                  setMessage("");
                }}
              >
                ✕
              </button>
            </form>
          </div>

          {message && (
            <div className="alert alert-error mb-3">
              <span className="text-sm">{message}</span>
            </div>
          )}

          <form onSubmit={Submit}>
            <div className="my-3 space-y-4">
              {/* Select PBO avec chargement */}
              <div>
                <label className="text-sm font-medium block mb-2">PBO</label>
                <div className="relative">
                  <select
                    className="select select-bordered w-full"
                    value={selectedPbo}
                    onChange={(e) => {
                      setSelectedPbo(e.target.value);
                      if (e.target.value) {
                        getListBrin(e.target.value);
                      } else {
                        setListeBrin([]);
                        setSelectedBrin("");
                      }
                    }}
                    disabled={loadingPbo || submited}
                  >
                    <option value="">
                      {loadingPbo
                        ? "Chargement des PBO..."
                        : "-- Sélectionner un PBO --"}
                    </option>
                    {listePbo?.map((pbo) => (
                      <option key={pbo.id} value={pbo.id}>
                        {pbo.nom}
                      </option>
                    ))}
                  </select>
                  {loadingPbo && (
                    <div className=" absolute right-12 top-1/2 -translate-y-1/2">
                      <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                    </div>
                  )}
                </div>
                {!loadingPbo && listePbo?.length === 0 && (
                  <p className="text-xs text-gray-500 mt-1">
                    Aucun PBO disponible
                  </p>
                )}
              </div>

              {/* Select Brin avec chargement */}
              <div>
                <label className="text-sm font-medium block mb-2">Brin</label>
                <div className="relative">
                  <select
                    className="select select-bordered w-full"
                    value={selectedBrin}
                    onChange={(e) => setSelectedBrin(e.target.value)}
                    disabled={!selectedPbo || loadingBrin || submited}
                  >
                    <option value="">
                      {!selectedPbo
                        ? "Sélectionnez d'abord un PBO"
                        : loadingBrin
                          ? "Chargement des brins..."
                          : "-- Sélectionner un Brin --"}
                    </option>
                    {listeBrin?.map((brin) => (
                      <option key={brin.id} value={brin.id}>
                        {brin.designation}
                      </option>
                    ))}
                  </select>
                  {loadingBrin && (
                    <div className=" absolute right-12 top-1/2 -translate-y-1/2">
                      <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                    </div>
                  )}
                </div>
                {!loadingBrin && selectedPbo && listeBrin?.length === 0 && (
                  <p className="text-xs text-gray-500 mt-1">
                    Aucun brin disponible pour ce PBO
                  </p>
                )}
              </div>

              {/* Bouton de soumission */}
              <div className="pt-3">
                <button
                  type="submit"
                  disabled={
                    submited ||
                    !selectedBrin ||
                    !selectedPbo ||
                    loadingPbo ||
                    loadingBrin
                  }
                  className={`btn btn-sm ${
                    submited ||
                    !selectedBrin ||
                    !selectedPbo ||
                    loadingPbo ||
                    loadingBrin
                      ? "btn-disabled opacity-50"
                      : "bg-main text-black border-main hover:bg-opacity-90"
                  }`}
                >
                  {submited ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      Enregistrement...
                    </>
                  ) : (
                    "Mettre à jour"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </dialog>

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {/* Filtres */}
        <div className="flex items-center gap-3 mb-4">
          <div className="relative flex-1 max-w-sm">
            <input
              type="text"
              value={searchTerm}
              disabled={attributions.loading}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Rechercher un élément..."
              className="text-xs input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
            />
            {isSearching && (
              <Loader2 className="w-4 h-4 animate-spin absolute right-3 top-3 text-gray-400" />
            )}
          </div>
        </div>

        {/* Grille des rendez-vous */}
        {loading ? (
          <div className="flex flex-col justify-center items-center py-20 space-y-3">
            <Loader2 className="w-8 h-8 animate-spin text-main" />
            <span className="ml-3 text-gray-600 text-sm">
              Chargement des données...
            </span>
          </div>
        ) : attributions?.data?.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-sm text-gray-500">Aucune donnée disponible</p>
          </div>
        ) : (
          <>
            <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {attributions?.data?.map((item) => (
                <div
                  key={item.id}
                  className={`${
                    !item?.inTime
                      ? "border-red-300 border-2 border-dashed"
                      : "border-slate-200 border"
                  } relative bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow`}
                >
                  <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                    <p className="text-[12px] font-semibold">
                      N° {item?.abonnement?.eligibilite?.numeroTicket}
                    </p>
                  </div>
                  <div className="px-3 py-2">
                    <div className="items-center gap-2 space-y-3">
                      <Periode item={item} />
                      <Pbo
                        pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                        port={item?.brin}
                      />
                      <div className="flex gap-1 my-3">
                        <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                        <div>
                          <p className="text-[13px] font-medium">
                            {item?.abonnement?.client?.nomPrenoms}
                          </p>
                          <p className="text-xs flex font-semibold gap-2">
                            <span>{item?.abonnement.client?.numero}</span>
                            {item?.abonnement.client?.secondNumero && (
                              <>
                                {" | "}
                                <span>
                                  {item?.abonnement.client?.secondNumero}
                                </span>
                              </>
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <CalendarIcon />
                            {item?.dateRdv}
                          </p>
                        </div>
                      </div>

                      <h1 className="text-xs flex gap-1 items-center my-2">
                        Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                        {item?.abonnement?.forfait?.categorie
                          ?.replace("_", "")
                          .toLowerCase()}
                      </h1>

                      <div className="gap-1">
                        <div>
                          <p className="text-[13px] font-medium">
                            Numero FTTH : {item?.abonnement?.numeroFtth}
                          </p>
                          <p className="text-xs flex font-semibold gap-2">
                            SN : <span>{item?.abonnement?.numeroSerie}</span>
                          </p>
                        </div>
                      </div>

                      <h1 className="text-xs flex gap-1 items-center my-2">
                        <AvatarIcon />
                        Equipe en charge : {item?.equipe?.designation}
                      </h1>
                      {item.commentaire && (
                        <div className="dropdown flex items-center">
                          <p className="text-xs">
                            Commentaire: {item?.commentaire}
                          </p>
                        </div>
                      )}
                      <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                        <p className="text-xs flex gap-1 items-center font-medium">
                          <HomeIcon />
                          {item?.abonnement?.batiment?.designation}
                        </p>
                        <p className="text-xs flex gap-1 font-medium">
                          <ArchiveIcon />
                          {item?.abonnement?.equipement?.designation}
                        </p>
                      </div>
                    </div>
                    <h1 className="my-2 text-[13px] font-medium flex items-center">
                      <SewingPinFilledIcon />
                      {item?.abonnement?.commune +
                        ", " +
                        item?.abonnement?.quartier}
                    </h1>
                    <div className="flex items-center gap-1">
                      <h5 className="text-xs font-medium">Etape:</h5>
                      <p className="bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                        {item?.abonnement?.status
                          ?.toLowerCase()
                          .replace(/_/g, " ")}
                      </p>
                    </div>
                    {item?.equipe && (
                      <div className="pt-2">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700">
                          Équipe: {item?.equipe?.designation}
                        </span>
                      </div>
                    )}
                    <div className="flex items-center gap-1">
                      {/* <button
                        onClick={() => {
                          setAssignModalItem(item);
                          getListePbo(
                            item?.abonnement?.eligibilite?.latitude,
                            item?.abonnement?.eligibilite?.longitude,
                          );
                          setSelectedPrestataire("");
                          setMsg("");
                          document.getElementById("edit").showModal();
                        }}
                        className="ml-auto text-white text-xs btn btn-sm bg-black"
                      >
                        <Pencil1Icon /> Modifier
                      </button> */}

                      <button
                        onClick={() => {
                          getEquipeListe(item?.prestataire?.id);
                          setAssignModalItem(item);
                          setSelectedPrestataire("");
                          setMsg("");
                          document.getElementById("reattribution").showModal();
                        }}
                        className="btn btn-sm bg-main border-main my-3 font-mtn text-xs font-regular hover:bg-opacity-90 transition-colors"
                      >
                        Reaffecter
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => moreEnAttente(newValue)}
            count={attributions?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>
      </div>
    </div>
  );
};

export default PrestataireAttributionCoordo;
